import React from "react"
import SearchResultDropdownStyle from "./SearchResultDropdwonStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const SearchResultDropdown = ({ food, handleGetMeal, locale }) => {
  return (
    <div>
      {food.length === 0 ? (
        <div />
      ) : (
        <div>
          <div className={SearchResultDropdownStyle.dropdown_holder}>
            {food.map(meal => {
              const { giMean, name, _id } = meal
              return (
                <div
                  role="button"
                  tabIndex={_id}
                  onKeyDown={() => {
                    handleGetMeal(_id)
                  }}
                  className={SearchResultDropdownStyle.result}
                  key={_id}
                  onClick={() => {
                    handleGetMeal(_id)
                  }}
                >
                  <p className={SearchResultDropdownStyle.result_name}>
                    {name}
                  </p>
                  <React.Fragment>
                    {giMean <= 55 ? (
                      <p className={SearchResultDropdownStyle.min}>
                        {translate(keys.LOW_GLYCEMIC_INDEX, locale)}
                      </p>
                    ) : (
                      <React.Fragment>
                        {" "}
                        {giMean > 55 && giMean <= 69 ? (
                          <p className={SearchResultDropdownStyle.average}>
                            {translate(keys.AVERAGE_GLYCEMIC_INDEX, locale)}
                          </p>
                        ) : (
                          <p className={SearchResultDropdownStyle.max}>
                            {translate(keys.HIGH_GLYCEMIC_INDEX, locale)}
                          </p>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchResultDropdown
